import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import data from "../../../utils/data/pages/blogData.json";

function BlogOne() {
    return (
        <Container>
            <div className="row mt-4" >
                <div className="col" >
                    <div className='home_row_line' ></div>
                    <h3 className="home-services-main-title">Our Blogs</h3>
                    <div className="row" >
                    </div>
                </div>
            </div>
            <Row className='justify-content-center mt-3' >
                {
                    data.map((d) => (
                        <Col className='p-2' xl={4} >
                            <div className="card facility_card mb-3">
                                <img src={d.image} className="img-fluid rounded-start" alt="..." />
                                <div className="card-body">
                                    <h5 className="card-title"> {d.title} </h5>
                                    <p className="card-text blog_p"> {d.text} </p>
                                </div>
                            </div>
                        </Col>
                    ))
                }
            </Row>
        </Container>
    )
}

export default BlogOne